import React from 'react'

export const renderCheckLicense = ({ input, placeholder, label, icon, type, meta: { touched, error, warning }, errorLicense }) => {
  // console.log('errorLicenxxxxse',error)
  return (
    <div className='dt-inputForm-block'>
      <div className='dt-inputText'>{label}</div>
      <div className={icon}>
        <input {...input} placeholder={placeholder} type={type} className='dt-input dt-input-w100'/>
      </div>
      {touched ? ((error && <span className='dt-inputMessage --show'>{error}</span>) || (errorLicense && <span className='dt-inputMessage --show'>Your license key is wrong, Please check agian.</span>)) : <span className='dt-inputMessage' />}
    </div>
  )
}
